import { render } from "./MenuAlert.vue?vue&type=template&id=81db7b0a"
import script from "./MenuAlert.vue?vue&type=script&lang=js"
export * from "./MenuAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__